export default {
  title: 'Analysis',
  running: 'Running analysis...',
  errorNoResult: "The table was created but it's empty, because the selected parameters produced no results.",
  creatingTable: 'Creating table...',
  errorMessages: {
    orderByNotAvailable:
      '`ORDER BY` clauses are not compatible with table optimization strategies like clustering. Please remove the `ORDER BY` from your query and try saving the result again.'
  }
}
